import React from "react";

const FormWrapperComponent = ({ children }: { children: any }) => (
  <div className="sid sid-form-wrapper">{children}</div>
);

export { FormWrapperComponent };
